export default {"gitHash":"56d9901186e3055dacb086a8c9499165ca9ef023","gitHashShort":"56d9901","time":1649500579660,"platform":"linux","arch":"x64"};